'use strict';

var $ = require('jquery');
var Debouncer = require('../lib/Debouncer.js');
var RangeInput = require('./RangeInput.js');
var Magnific = require('magnific-popup');
var Masonry = require('masonry-layout');

function init() {
	if (!document.getElementsByClassName('__countrySelector').length)
		return

	/**
	 * Parses the attribute of an HTML element into an integer
	 * @param {HTMLElement} el The element to look for the attribute on
	 * @param {string} att The suffix of the data- attribute
	 * @returns {number} The parsed attribute
	 */
	function parseAttribute(el, att) {
		var result = parseInt(el.getAttribute('data-' + att), 10);
		return isNaN(result) ? 0 : result;
	}

	// Set up range selector
	document.getEl
	var rangeEl = document.getElementsByClassName('formFilter__range')[0];
	if (rangeEl) {
		var min = parseAttribute(rangeEl, 'min');
		var max = parseAttribute(rangeEl, 'max');
		if (min === max) {
			max++;
		}

		RangeInput.init({
			element: 'formFilter__rangeField',
			min: min,
			max: max
		});
	}

	// Filter Elements
	var filterSection = document.getElementsByClassName('filterByCommittee')[0];
	var filterHeading = document.getElementsByClassName('filterByCommittee__heading')[0];
	var filterContent = document.getElementsByClassName('filterByCommittee__content')[0];

	// Popup (mobile only)
	$(filterHeading).magnificPopup({
		items: {
			src: $(filterContent).contents(),
			type: 'inline'
		},
		disableOn: function() {
			return window.innerWidth <= 730;
		},
		closeOnBgClick: false,
		fixedBgPos: true,
		mainClass: 'countrySelector__modal'
	});

	$('.btn', filterContent).on('click', function() {
		$.magnificPopup.instance.close();
	});

	// Set up filter accordion
	function filterHeadingClick() {
		filterHeading.classList.toggle('filterByCommittee__heading--active');
		filterSection.classList.toggle('filterByCommittee--active');

		if (!document.documentElement.classList.contains('IE9')) {
			filterSection.classList.add('filterByCommittee--animating');
			filterSection.addEventListener('transitionend', function(e) {
				filterSection.classList.remove('filterByCommittee--animating');
			});
		}
	}

	var msnry = undefined;
	function filterAreaHandling() {
		var isMobile = window.innerWidth <= 730;
		if (isMobile) {
			// Remove accordion logic and class
			filterHeading.removeEventListener('click', filterHeadingClick);
			filterSection.classList.remove('filterByCommittee--active');

			if (msnry) {
				msnry.destroy();
				msnry = null;
			}
		} else {
			filterHeading.addEventListener('click', filterHeadingClick);

			// Remove unneeded MFP classes
			$('.mfp-hide').removeClass('mfp-hide');

			// Set up filter results masonry
			msnry =
				new Masonry('.filterByCommitteeFieldSets', {
					percentPosition: true,
					horizontalOrder: true
				});
		}
	}

	window.addEventListener('load', filterAreaHandling);

	var resizeDebouncer = new Debouncer(filterAreaHandling);
	window.addEventListener('resize', resizeDebouncer.run);
}

module.exports = {
	init: init
}
